var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeslider1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 0.666656V22.4167H17.0834V0.666656H0.166748ZM11.0417 16.375H3.79175V15.1667H11.0417V16.375ZM13.4584 12.75H3.79175V11.5417H13.4584V12.75ZM13.4584 9.12499H3.79175V7.91666H13.4584V9.12499ZM13.4584 5.49999H3.79175V4.29166H13.4584V5.49999Z",
    fill: "#F15412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeslider1);
export default __webpack_public_path__ + "static/media/homeslider1.2d1b3c4a0c426c9d26437e4f2a1d67a9.svg";
export { ForwardRef as ReactComponent };